module.exports = __webpack_public_path__ + "static/2-62a28ae0ff1a698293117f5d0459e6ba.jpg";